import type { PoiType } from "./db.ts"

export const POI_TYPE_LABELS: Record<PoiType, string> = {
  photo: "Photo",
  video: "Video",
  water_source: "Water source",
  food_cache: "Food cache",
  trail_junction: "Trail junction",
  camp_site: "Camp site",
}

export const POI_TYPE_ICONS: Record<PoiType, string> = {
  photo: "📷",
  video: "▶",
  water_source: "💧",
  food_cache: "🥫",
  trail_junction: "🔀",
  camp_site: "⛺",
}

export const GEOGRAPHIC_TYPE_KEYS = [
  "water_source",
  "food_cache",
  "trail_junction",
  "camp_site",
] as const satisfies PoiType[]

export type GeographicType = (typeof GEOGRAPHIC_TYPE_KEYS)[number]

export const GEOGRAPHIC_TYPES = new Set<GeographicType>(GEOGRAPHIC_TYPE_KEYS)
